import Icon from '../components/Icon.vue'

Icon.register({
  'folder-minus': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 128c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-288c0-26.5 21.5-48 48-48h160l64 64h192zM368 296v-16c0-8.8-7.2-16-16-16h-192c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16z'
      }
    ]
  }
})
